import { FunnelPlusIcon, FunnelXIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import { Button, SheetTrigger } from '@/_components';
import { hotKeys, useShortcutKey } from '@/_shared';

import type { AdvanceFilter } from './types';
import { useFiltersContext } from './use-filters-context';

export function FilterTrigger<T>({ advFilters }: { advFilters: AdvanceFilter<T>[] }) {
  const appliedFilters = advFilters.filter((f) => f.applied);
  const hasActiveFilters = appliedFilters.length > 0;
  const { setSidebarOpen, sidebarOpen } = useFiltersContext();
  const { osKey } = useShortcutKey(hotKeys.openFilters, () => {
    setSidebarOpen(!sidebarOpen);
  });

  return (
    <SheetTrigger tabIndex={-1}>
      <Button
        tag="div"
        size="sm"
        theme={hasActiveFilters ? 'warning' : 'primary'}
        iconLeft={!hasActiveFilters ? FunnelPlusIcon : FunnelXIcon}
        className="pr-10"
        onClick={() => {
          setSidebarOpen(!sidebarOpen);
        }}
      >
        {!hasActiveFilters ? 'Filter' : `Filter (${appliedFilters.length})`}
        <div
          className={twMerge(
            'absolute right-2.5 bottom-1.75 rounded-sm border px-1 py-0 text-[10px] opacity-70',
            hasActiveFilters ? 'border-accent' : 'border-white/70'
          )}
        >
          {osKey}.
        </div>
      </Button>
    </SheetTrigger>
  );
}
